module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgInner affairEdit"
  }, [_c('div', {
    staticClass: "headBar"
  }, [_vm._v("角色管理")]), _vm._v(" "), _c('div', {
    staticClass: "pgbody",
    style: ('height:' + _vm.pageH + 'px;')
  }, [_c('el-scrollbar', {
    ref: "scroller",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "tabContent"
  }, [_c('AddRule', {
    ref: "AddRule",
    attrs: {
      "article": _vm.param.dto
    },
    on: {
      "inited": _vm.readyHandle
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "pagefoot"
  }, [(_vm.pgState) ? _c('div', {
    staticClass: "loading"
  }, [(_vm.pgState == 1) ? _c('span', [_vm._v("初始化中...")]) : _vm._e(), _vm._v(" "), (_vm.pgState == 2) ? _c('span', [_vm._v("数据保存中...")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.goSave()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goReturn
    }
  }, [_vm._v("返回")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-8a989be8"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/pgment/rule/add/index.vue
// module id = 1541
// module chunks = 1